import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Chip, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getOfferHistory } from '../../api/oferte'

const STATUS_LABEL: Record<string, string> = {
  Draft: 'Ciornă', PendingApproval: 'În aprobare', Approved: 'Aprobată', Sent: 'Trimisă',
  Expired: 'Expirată', Converted: 'Convertită', Rejected: 'Respinsă',
}

export default function OfferHistoryDialog({ offerNumber, onClose }: { offerNumber: string | null; onClose: () => void }) {
  const open = offerNumber !== null
  const { data } = useQuery({
    queryKey: ['comercial', 'oferte', 'istoric', offerNumber],
    queryFn: () => getOfferHistory(offerNumber!),
    enabled: open,
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Istoric revizii — {offerNumber}</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5} sx={{ mt: 0.5 }}>
          {data?.map((v) => (
            <Stack key={v.id} direction="row" spacing={2} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>V{v.versionNumber}</Typography>
              <Typography variant="body2" color="text.secondary">{v.offerDate}</Typography>
              <Chip size="small" variant="outlined" label={STATUS_LABEL[v.status] ?? v.status} />
              <Typography variant="body2">{v.total.toFixed(2).replace('.', ',')}</Typography>
            </Stack>
          ))}
          {data?.length === 0 && <Typography color="text.secondary">Nicio versiune găsită.</Typography>}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose}>Închide</Button>
      </DialogActions>
    </Dialog>
  )
}
